import type { PublicRoomType } from '../api/types'
import { rooms as staticRooms, type Room } from './rooms'

function normalize(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

const aliases: Record<string, string> = {
  // Backend type "Triple o Familiar" is marketed as Master Suite.
  'triple-o-familiar': 'master-suite',
}

function matchStatic(backendName: string): Room | undefined {
  const norm = normalize(backendName)
  const direct = staticRooms.find((r) => r.slug === norm)
  if (direct) return direct
  const aliased = aliases[norm]
  if (aliased) return staticRooms.find((r) => r.slug === aliased)
  const keyed = staticRooms.find((r) =>
    norm.includes(r.slug) || r.slug.includes(norm),
  )
  return keyed
}

export function mergeBackendRooms(backend: PublicRoomType[] | undefined): Room[] {
  if (!backend || backend.length === 0) return staticRooms

  const merged: Room[] = []
  for (const bt of backend) {
    const fallback = matchStatic(bt.name)
    const price = Math.round(Number(bt.base_price))
    const backendImages = (bt.images || [])
      .map((img) => img.image)
      .filter(Boolean) as string[]
    merged.push({
      slug: fallback?.slug ?? normalize(bt.name),
      translationKey: fallback?.translationKey ?? normalize(bt.name).replace(/-/g, '_'),
      price: Number.isFinite(price) && price > 0 ? price : fallback?.price ?? 0,
      capacity: bt.max_occupancy ?? fallback?.capacity ?? 2,
      images: backendImages.length > 0 ? backendImages : fallback?.images ?? [],
      amenities: Array.isArray(bt.amenities)
        ? bt.amenities
        : fallback?.amenities ?? [],
      module: fallback?.module ?? 'colonial',
      size: fallback?.size ?? '—',
      bed: fallback?.bed ?? 'Queen',
      room_type_id: bt.room_type_id,
      backend_name: bt.name,
      backend_description: bt.short_description || bt.marketing_description,
    })
  }
  return merged
}
